import "./credit.css";
import { Link } from "react-router-dom";
import React, { useState, useEffect, Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Footer from "./footer";
import Chairman from "../images/Chairman.jpg";
import MainBg from "../images/Leadership main bg.jpg";
import men from "../images/men.png";
import Mobilemen from "../images/mobile-men.png";
import Ceo from "../images/Ojiromayo.jpg";
import ED from "../images/Abayomi.jpg";
import Internal from "../images/Yomi.jpg";
import InternalAud from "../images/Segun.jpg";
import RiskMMng from "../images/Kingsley.jpg";
import ready from "../images/avc-ready.jpg";
import benefits from "../images/avc-benefits.jpg";
import creditBanner from "../images/credit-banner.jpg";
import creditProcessed from "../images/credit-processed.png";
import creditUnprocessed from "../images/credit-unprocessed.png";
import creditTransactional from "../images/credit-transactional.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import AOS from 'aos';

import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";

const client = new ApolloClient({
  link: new HttpLink({
    uri: "https://pensure-cms.inspireleadership.biz/graphql",
  }),
  cache: new InMemoryCache(),
});

const Credit = () => {
  window.scrollTo(0, 0);

  const [heroBanner, setHeroBanner] = useState([]);
  const [heroMobile, setHeroMobile] = useState([]);
  const [listSections, setListSections] = useState([]);

   useEffect(() => {
          
             AOS.init({
              offset: 0,
              duration: 1000,
              once: true
            });
          
              
          }, [])

  useEffect(() => {
    client
      .query({
        query: gql`
          query NewQuery {
            pages {
              edges {
                node {
                  id
                  creditcontribution {
                    listSection {
                      heading
                      caption
                      image {
                        mediaItemUrl
                      }
                      list {
                        item
                      }
                      buttonName
                      buttonLink
                    }
                    heromobile {
                      buttonLink
                      buttonName
                      caption
                      heading
                      image {
                        mediaItemUrl
                      }
                    }
                    hero {
                      buttonLink
                      buttonName
                      caption
                      heading
                      image {
                        mediaItemUrl
                      }
                    }
                  }
                }
              }
            }
          }
        `,
      })
      .then((result) => {
        console.log(result);

        setHeroBanner(result.data.pages.edges[8].node.creditcontribution.hero);
        setHeroMobile(
          result.data.pages.edges[8].node.creditcontribution.heromobile,
        );
        setListSections(
          result.data.pages.edges[8].node.creditcontribution.listSection,
        );
      });
  }, []);

  let heroBannerDisplay;
  let heroMobileBannerDisplay;

  let listSectionsDisplay;

  if (heroBanner.length > 0) {
    heroBannerDisplay = heroBanner.map((banner, i) => (
      <div className="credit-cover">
        <img className="credit-bg" src={banner.image.mediaItemUrl} />
        <div className="credit-content">
          <div className="credit-txt">
            <h1 className="credit-h1 "  data-aos="zoom-in" data-aos-delay="200">{banner.heading}</h1>
            <p className="grey-p-credit"  data-aos="fade-up" data-aos-delay="200">{banner.caption}</p>
            <a href={banner.buttonLink} className="btn-trns"  data-aos="fade-up" data-aos-delay="200">
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (heroMobile.length > 0) {
    heroMobileBannerDisplay = heroMobile.map((banner, i) => (
      <div className="credit-cover">
        <img className="credit-bg" src={banner.image.mediaItemUrl} />
        <div className="credit-content">
          <div className="credit-txt">
            <h1 className="credit-h1"  data-aos="zoom-in" data-aos-delay="200">{banner.heading}</h1>
            <p className="grey-p-credit"  data-aos="fade-up" data-aos-delay="200">{banner.caption}</p>
            <a href={banner.buttonLink} className="btn-trns"  data-aos="fade-up" data-aos-delay="200">
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (listSections.length > 0) {
    listSectionsDisplay = listSections.map((section, i) =>
      i % 2 ? (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5 z-value"
        >
          <div className="d-flex d-none d-sm-block justify-content-end">
            <img className="uncredited-img" src={section.image.mediaItemUrl} />
          </div>

          <div className="pension-div1 pb-5">
            <h3 className="rma-h3 pb-2"  data-aos="fade-up" data-aos-delay="200"> {section.heading} </h3>

            <p
              className="grey-p-pms  pb-2 "
              style={{ color: "#3B475A", width: "470px" }}
             data-aos="fade-up" data-aos-delay="200" >
              {section.caption}
            </p>

            <hr
              className="btm-bdr"
              style={{ borderTop: "none", width: "600px" }}
            />

            <ul
              className="pt-2 ps-3 custom-square"
              style={{ listStyleType: "square", paddingLeft: "20px" }}
            >
              {section.list.map((items, i) => (
                <li className="grey-p-rma pt-4" style={{ color: "#3B475A" }}  data-aos="fade-up" data-aos-delay="200">
                  {items.item}
                </li>
              ))}
            </ul>

            <a
              class="open-acc-btn grey-p-credit mt-5"
              href={section.buttonLink}
              role="button"
               data-aos="fade-up" data-aos-delay="200"
   
            >
              {section.buttonName}{" "}
              <FontAwesomeIcon className="credit-dwn-arr" icon={faArrowRight} />
            </a>
          </div>

          <div className="d-flex d-block d-sm-none justify-content-end">
            <img className="uncredited-img" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ) : (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between pb-5 z-value"
        >
          <div className="pension-div1 pb-2">
            <h3 className="rma-h3 pb-2"  data-aos="fade-up" data-aos-delay="200">{section.heading}</h3>

            <p
              className="grey-p-pms  pb-2 "
              style={{ color: "#3B475A", width: "470px" }}
               data-aos="fade-up" data-aos-delay="200"
            >
              {section.caption}
            </p>

            <hr
              className="btm-bdr"
              style={{ borderTop: "none", width: "600px" }}
            />

            <ul
              className="pt-2 ps-3 custom-square"
              style={{ listStyleType: "square", paddingLeft: "20px" }}
            >
              {section.list.map((items, i) => (
                <li className="grey-p-rma pt-4" style={{ color: "#3B475A" }}  data-aos="fade-up" data-aos-delay="200">
                  {items.item}
                </li>
              ))}
            </ul>

            <a
              id="withdrawal-btn"
              class="open-acc-btn grey-p-credit mt-5"
              href={section.buttonLink}
              role="button"
              data-aos="fade-up" data-aos-delay="200"
          
            >
              {section.buttonName}{" "}
              <FontAwesomeIcon className="credit-dwn-arr" icon={faArrowRight} />
            </a>
          </div>

          <div className="d-flex justify-content-end">
            <img className="uncredited-img" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ),
    );
  }

  return (
    <>
      <div className="credit-container d-block d-sm-none">
        {heroBannerDisplay}
      </div>

      <div className="credit-container d-none d-sm-block">
        {heroMobileBannerDisplay}
      </div>

      <div className="containeer padding-section-standard-top">
        {listSectionsDisplay}
      </div>

           <Footer/>
           <div className='height-prod'> 

              </div>
    </>
  );
};

export default Credit;
